import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 7.82 13",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.82 13\" id=\"icon-chevron-right\"><path d=\"M7.82,6.5,1.74,13,0,11.27,4.35,6.5,0,1.73,1.74,0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/chevron-right.svg
// module id = 277
// module chunks = 0 1